// Endpoints.[controller].[action]

export const EndpointsAdmin = {
  account: {
    add: '/api/v1/admin/account/Add',
    edit: '/api/v1/admin/account/Edit',
    remove: '/api/v1/admin/account/Remove',
    get: '/api/v1/admin/account/Get',
    getAll: '/api/v1/admin/account/GetAll',
    getEmployeeTypes: '/api/v1/admin/account/GetEmployeeTypes',
    getRoles: '/api/v1/admin/account/GetRoles',
    getUserName: '/api/v1/admin/account/GetUserName',
    resetPassword: '/api/v1/admin/account/ResetPassword'
  },
  template: {
    add: '/api/v1/admin/template/Add',
    edit: '/api/v1/admin/template/Edit',
    remove: '/api/v1/admin/template/Remove',
    get: '/api/v1/admin/template/Get',
    getAll: '/api/v1/admin/template/GetAll'
  },
  employeeType: {
    add: '/api/v1/admin/employeetype/Add',
    edit: '/api/v1/admin/employeetype/Edit',
    remove: '/api/v1/admin/employeetype/Remove',
    get: '/api/v1/admin/employeetype/Get',
    getAll: '/api/v1/admin/employeetype/GetAll'
  },
  announcement: {
    add: '/api/v1/admin/announcement/Add',
    edit: '/api/v1/admin/announcement/Edit',
    remove: '/api/v1/admin/announcement/Remove',
    get: '/api/v1/admin/announcement/Get',
    getAll: '/api/v1/admin/announcement/GetAll'
  },
  project: {
    getAll: '/api/v1/admin/project/GetAll',
    remove: '/api/v1/admin/project/remove'
  }
}
